import { NgRxAction } from '@stop-counter/store';
export var Actions;
(function (Actions) {
    Actions["LOAD"] = "[Posts] LOAD Requested";
    Actions["LOAD_SINGLE"] = "[Post] LOAD Requested";
    Actions["LOAD_SUCCESS"] = "[Posts] LOAD Success";
    Actions["ERROR"] = "[Posts] Error";
})(Actions || (Actions = {}));
export class LoadAction extends NgRxAction {
    constructor() {
        super(...arguments);
        this.type = Actions.LOAD;
    }
}
export class LoadSingleAction extends NgRxAction {
    constructor() {
        super(...arguments);
        this.type = Actions.LOAD_SINGLE;
    }
}
export class LoadSuccessAction extends NgRxAction {
    constructor() {
        super(...arguments);
        this.type = Actions.LOAD_SUCCESS;
    }
}
export class ErrorAction extends NgRxAction {
    constructor() {
        super(...arguments);
        this.type = Actions.ERROR;
    }
}
